<div class="row ui-g-12">
  Please Select a Date:
</div>

<div class="row ui-g-12">
  <div class="calendar-container ml-lg-2">
    <p-calendar [(ngModel)]="timeSlotsData.selectedDate" class="notranslate" placeholder="Select Date" [showIcon]="true"
      [numberOfMonths]="1" [minDate]="timeSlotsData.minDate" [maxDate]="timeSlotsData.maxDate"
      (ngModelChange)="onDateChange()"></p-calendar>
  </div>
</div>

<div class="row ui-g-12">
  <div class="time-slots-container ml-lg-3 mt-lg-2">

    <ng-container *ngIf="this.timeSlotsData.show_empty_messsage; else show_slots">
      No Appointments Available. Please Select Specialty before choosing the slot.
    </ng-container>

    <ng-template #show_slots>
      <ng-container *ngIf="timeSlotsData.timeSlots.length">
        <div class="row ui-g-12">
          Please Select a Appointment Time:
        </div>

        <div class="row ui-g-12">
          <ng-container *ngFor="let slot of timeSlotsData.timeSlots">
            <div class="col-6 col-md-3 ui-g-6 ui-md-3">
              <div class="time-slot" style="text-align: center;" [ngClass]="{ 'selected': timeSlotsData.selectedSlot === slot.value }"
                (click)="onSlotSlected(slot)">
                {{ slot.label }}
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-template>

  </div>
  <div class="row ui-g-12">
    <p>
      <span style="color:green"><b>Note:</b></span> If there are no slots available or you do not
      wish to select a slot for your appointment our support
      team will call you to confirm the timings of your
      appointment within 2-3 business days.
    </p>
  </div>
</div>